import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import configOldMovementsEsCL from './locales/es-CL.json';
import configOldMovementsEnUS from './locales/en-US.json';
import configOldMovementsPtBR from './locales/pt-BR.json';

export const configOldMovementsI18n = buildScopedI18n({
  esCL: configOldMovementsEsCL,
  enUS: configOldMovementsEnUS,
  ptBR: configOldMovementsPtBR,
});
